import * as Yup from 'yup';

export const colorRegex = /(?:#|0x)(?:[a-f0-9]{3}|[a-f0-9]{6})\b|(?:rgb|hsl)a?\([^\\)]*\)/;

export const COLOR_ERROR_MESSAGE = 'This field must be a valid Hex color';
export const FIELD_REQUIRED_MESSAGE = 'This field is required';
export const IMAGE_REQUIRED_MESSAGE = 'This image is required';
export const SECTIONS_REQUIRED_MESSAGE = 'At least one section should be enabled';
export const INVALID_URL_MESSAGE = 'This URL is not valid';

export const fullUrlRegexp = /[-a-zA-Z0-9@:%._\\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\\+.~#?&//=]*)/;

export const MAX_BANNERS_COUNT = 6;

export const UrlValidator = Yup.string().matches(fullUrlRegexp, INVALID_URL_MESSAGE);
